type OwnProps = {
  name: string;
  color?: string;
  style?: $TSFixMe;
};

const defaultProps: Partial<OwnProps> = {
  style: undefined,
  color: undefined,
};

type Props = OwnProps & typeof defaultProps;

function Icon({ name, color, style }: Props) {
  return (
    <i
      className={`icon ${name}`}
      data-testid={`icon ${name}`}
      style={style ? { ...style, color } : { color }}
    />
  );
}

Icon.defaultProps = defaultProps;

export default Icon;
